import { redirect } from "react-router-dom";

import store from "store";
import { refreshToken } from "features/auth/authAction";
import { getUserProfile } from "features/user/userAction";
import { PERMISSION_DENIED_ERROR } from "config/keywords";
import { LOGIN_PATH } from "./pathName";

// dispatch() of a thunk never throws; a failure comes back as a rejected
// action, so the results have to be checked.
const rootLoader = async () => {
  if (!store.getState().auth.token) {
    const refreshAction = await store.dispatch(refreshToken());
    if (refreshToken.rejected.match(refreshAction)) return redirect(LOGIN_PATH);
  }
  const profileAction = await store.dispatch(getUserProfile());
  // A denied role has already been signed out by getUserProfile. Any other
  // failure (e.g. a network error) must not log the user out.
  if (
    getUserProfile.rejected.match(profileAction) &&
    profileAction.payload === PERMISSION_DENIED_ERROR
  ) {
    return redirect(LOGIN_PATH);
  }
  return null;
};

export default rootLoader;
